import { call, put, select, takeLatest } from "redux-saga/effects";
import { UPDATE_COMMUNICATION } from "./constants";
import {
  updateCommunicationSuccess,
  updateCommunicationError,
} from "./actions";

import requestWrapper from "utils/requestWrapper";

// utils
import api from "utils/api";
const { endpoint } = api;
import _local from "utils/localStorageUtils";

export function* updateCommunicationSaga(action) {
  try {
    // we retrieve the token from the local storage
    const currentUser = yield _local.getLocalUser();
    const localActiveChild = yield _local.getLocalChild();
    const newKey = "new";
    const prentID = currentUser?._id;
    const childID = localActiveChild?._id;

    const { itemDetail } = action;

    let updatedElement = false,
      isNew = !itemDetail.hasOwnProperty("_id");

    if (isNew && !!prentID && !!childID) {
      updatedElement = yield requestWrapper(
        "POST",
        endpoint?.communications?.parent?.new(prentID, childID),
        // `communications/parent/${prentID}/child/${childID}/new`,
        itemDetail,
        currentUser.token,
      );
    }

    if (!updatedElement) {
      yield put(updateCommunicationSuccess(false));
    } else {
      yield put(updateCommunicationSuccess(updatedElement));
    }
  } catch (err) {
    yield put(updateCommunicationError(true));
  }
}

// Individual exports for testing
export default function* communicationNewMobileSaga() {
  yield takeLatest(UPDATE_COMMUNICATION, updateCommunicationSaga);
}
